import React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import FlagIcon from "@mui/icons-material/Flag";
import { Box } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import { Flag } from "../types";
import { DeleteFlag } from "../delete/DeleteFlag";
import { CreateEditFlag } from "../create-edit/CreateEdit";
import { useDataGrid } from "@refinedev/mui";
import { useGetLocale } from "@refinedev/core";
import { trTR, enUS } from "@mui/x-data-grid/locales";
import { useTranslation } from "../../../../hooks/useTranslation";

export const FlagList = () => {
  const { getLocale, translate } = useTranslation("pages.orders.flag");
  const locale = getLocale();
  const tableLocale = useGetLocale();
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
  const [editDialogOpen, setEditDialogOpen] = React.useState(false);
  const [selectedFlag, setSelectedFlag] = React.useState<Flag | null>(null);

  const { dataGridProps } = useDataGrid<Flag>({
    resource: "store/user-flags",
  });

  const handleEdit = (row: Flag) => {
    setSelectedFlag(row);
    setEditDialogOpen(true);
  };

  const handleDelete = (row: Flag) => {
    setSelectedFlag(row);
    setDeleteDialogOpen(true);
  };

  const columns: GridColDef<Flag>[] = [
    { field: "id", headerName: translate("flagId"), flex: 1 },
    { field: "flagName", headerName: translate("flagTitle"), flex: 1 },
    {
      field: "flagColor",
      headerName: translate("flagColor"),
      flex: 1,
      renderCell: (params) => (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          width="100%"
          height="100%"
        >
          <FlagIcon fontSize="large" sx={{ color: params.value }} />
        </Box>
      ),
    },
    {
      field: "created",
      headerName: translate("created"),
      flex: 2,
      renderCell: (params) => {
        const date = new Date(params.row.created);
        return <span>{date.toLocaleString(locale)}</span>;
      },
    },
    {
      field: "actions",
      headerName: translate("actions"),
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          width="100%"
          height="100%"
        >
          <IconButton onClick={() => handleEdit(params.row)}>
            <EditIcon color="primary" />
          </IconButton>
          <IconButton onClick={() => handleDelete(params.row)}>
            <DeleteIcon color="error" />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <>
      <DataGrid
        {...dataGridProps}
        columns={columns}
        sx={{}}
        getRowId={(row) => row.id}
        localeText={
          (tableLocale() === "tr" ? trTR : enUS).components.MuiDataGrid
            .defaultProps.localeText
        }
      />
      {selectedFlag && (
        <>
          <DeleteFlag
            open={deleteDialogOpen}
            onClose={() => {
              setDeleteDialogOpen(false);
              setSelectedFlag(null);
            }}
            flag={selectedFlag}
          />

          <CreateEditFlag
            open={editDialogOpen}
            onClose={() => {
              setEditDialogOpen(false);
              setSelectedFlag(null);
            }}
            flag={selectedFlag}
          />
        </>
      )}
    </>
  );
};
